const MAX_LEN = 120;

/** One-line label for the composer after submit. Prefers the stored case summary. */
export function submittedCaseLine(result, queryText) {
  const stored = String(result?.case_summary || "").replace(/\s+/g, " ").trim();
  if (stored && stored !== "—") return stored;
  const raw = String(queryText || "").replace(/\s+/g, " ").trim();
  if (!raw) return "";
  const match = raw.match(/^(.+?[.!?…])(?:\s|$)/);
  const chunk = (match ? match[1] : raw).trim();
  if (chunk.length <= MAX_LEN) return chunk;
  const cut = chunk.slice(0, MAX_LEN).replace(/\s+\S*$/, "");
  const base = cut.length >= MAX_LEN / 2 ? cut : chunk.slice(0, MAX_LEN);
  return `${base}…`;
}
